import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { DataService } from "src/app/services/data.service";
import { NotificationService } from "src/app/services/notification-service/notification.service";
import { cereateDemandeLicence, createDemandeLicenceFailure, createDemandeLicenceSuccess, getAllDemandeLicence, getAllDemandeLicenceFailure, getAllDemandeLicenceSuccess } from "../actions/demande-licence.action";
import { catchError, exhaustMap, map, of, tap } from "rxjs";

@Injectable()
export class DemandeLicenceEffect {

  loadDemandeLicences$ = createEffect(() => this.actions$.pipe(
    ofType(getAllDemandeLicence),
    exhaustMap(({ element, page, size, utilisateurId }) => this.dataService.loadDemandeLicenceData(element, page, size, utilisateurId).pipe(
      map((reponseDAO) => getAllDemandeLicenceSuccess(reponseDAO)),
      catchError((error) => of(getAllDemandeLicenceFailure({ error })))
    ))
  ))

  createDemandeLicence$ = createEffect(() => this.actions$.pipe(
    ofType(cereateDemandeLicence),
    exhaustMap(({ demandeLicence }) => this.dataService.createObject('DemandeLicence', demandeLicence).pipe(
      map((reponseDAO) => createDemandeLicenceSuccess(reponseDAO)),
      catchError((error) => of(createDemandeLicenceFailure({ error })))
    )),
    tap((action) => {
      if (action.type === '[DemandeLicence] Create Demande Licence Success') {
        this.notificationService.success("Demande de licence ajouté avec succès !");
        this.router.navigate(['demand-licence']);
      }
    })
  ))

  constructor(private actions$: Actions, private notificationService: NotificationService, private router: Router, private dataService: DataService) { }
}